import React from 'react';
import { Atomic } from '@atomicfi/transact-javascript';

function AtomicModal({ isOpen, operation = 'verify', publicToken, hasPinwheel, setIsOpen, onSuccess, updateAccount, reauth, onContinue, onError, companyId }) {
    const ddsCompletedRef = React.useRef(false);
    const taCompletedRef = React.useRef(false);
    const transactInstanceRef = React.useRef(null);

    React.useEffect(() => {
        if (isOpen) {
            ddsCompletedRef.current = false;
            taCompletedRef.current = false;
        }
    }, [isOpen]);

    React.useEffect(() => {
        if (!isOpen || !publicToken) {
            return;
        }

        const launchAtomic = async () => {
            try {
                const config = {
                    publicToken: publicToken,
                    tasks: [{ operation }],
                    scope: 'user-link',
                    theme: { dark: false },
                    language: 'en',
                    deeplink: { step: 'search-company' },
                };

                if (operation === 'deposit') {
                    config.deeplink.step = 'login-company';
                    config.deeplink.companyId = companyId;
                }

                const transact = {
                    config,
                    onFinish: async (data) => {
                        try {
                            if (hasPinwheel) {
                                ddsCompletedRef.current = true;
                                updateAccount?.();
                                setIsOpen(false);
                            } else {
                                const accountId = data?.identifier?.split(':')[1] || 'error';
                                const platformId = data?.company?._id || 'atomic';
                                if (typeof onSuccess === 'function') {
                                    await onSuccess(accountId, platformId, reauth);
                                }
                                taCompletedRef.current = true;
                            }
                        } catch (error) {
                            console.error('Atomic onFinish handler error:', error);
                            onError?.(error);
                        }
                    },
                    onClose: (data) => {
                        if (!hasPinwheel) {
                            setIsOpen(false);
                            if (taCompletedRef.current && typeof onContinue === 'function') {
                                onContinue();
                            }
                        } else {
                            if (ddsCompletedRef.current) {
                                // Already handled in onFinish
                            } else {
                                setIsOpen(false);
                            }
                        }
                    },
                    onInteraction: (interaction) => {
                        console.log('Atomic interaction:', interaction?.name, interaction?.value);
                    },
                    onDataRequest: (request) => {
                        console.log('Atomic data request:', request?.fields);
                        return {};
                    },
                };

                transactInstanceRef.current = Atomic.transact(transact);
            } catch (error) {
                console.error('Failed to launch Atomic Transact:', error);
                onError?.(error);
                setIsOpen(false);
            }
        };

        launchAtomic();

        return () => {
            if (transactInstanceRef.current?.close) {
                try {
                    transactInstanceRef.current.close();
                } catch (e) {
                    // Ignore cleanup errors
                }
            }
        };
    }, [isOpen, publicToken, hasPinwheel, setIsOpen, onSuccess, updateAccount, reauth, onContinue, onError, operation, companyId]);

    return null;
}

export default AtomicModal;
